export enum EventLogField {
	LOGOUT = "Разлогинить",
	REBOOT = "Перезапустить",
	DELETE = "Удалить",
	incomingWebhook = "Уведомления о входящих сообщениях",
	markIncomingMessagesReaded = "Отмечать входящие сообщения прочитанными",
	markIncomingMessagesReadedOnReply = "Отмечать входящие сообщения прочитанными при отправке через API",
	WEBHOOK_URL = "Адрес отправки уведомлений",
	outgoingWebhook = "Получать уведомления о статусах отправленных сообщений",
	outgoingMessageWebhook = "Получать уведомления о сообщениях, отправленных с телефона",
	outgoingAPIMessageWebhook = "Получать уведомления о сообщениях, отправленных  с API",
	stateWebhook = "Получать уведомления об изменении состояния авторизации",
	keepOnlineStatus = "Выставлять статус - (В сети)",
}
